import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { RecaudoFormHelper } from 'src/app/helpers/RecaudoFormHelper';
import { recaudoUI } from 'src/app/helpers/RecaudoUI';
import { CollectionView } from 'wijmo/wijmo';
import { Año } from 'src/app/helpers/Models';
import { WjFlexGrid, WjFlexGridColumn } from 'wijmo/wijmo.angular2.grid';
import { ToastrService } from 'ngx-toastr';
import { WijmoHelper, ModeloCollectionView } from 'src/app/helpers/WijmoHelper';
import { ModeloService, MatriculaService, ResponsablePagoService, EstudianteService, OtrasPersonasService, CobrosService, RecibosService, ExtractoService, TareaServidorService } from 'src/app/shared/services/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AutoSizeMode } from 'wijmo/wijmo.grid';
import { TareaServidorComponent } from '../tarea-servidor/tarea-servidor.component';
import { Informe } from 'src/app/_models/informe';
import { TableService } from 'src/app/shared/services/table';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

@Component({
  selector: 'app-tareas-servidor',
  templateUrl: './tareas-servidor.component.html',
  styleUrls: ['./tareas-servidor.component.css']
})
export class TareasServidorComponent extends RecaudoFormHelper implements OnInit {

  anio: Año = recaudoUI.getAñoTrabajo();
  countItems: number = 0;
  currentPage: number = 1;

  informe: Informe;
  hayCambios = false;

  @Input('tareasServidor') public tareasServidor: any;

  //CollectionViews
  cvTareasServidor: CollectionView;

  //Referencia a los controles de wijmo
  @ViewChild('flexTareasServidor') flexTareasServidor: WjFlexGrid;
  @ViewChild('ngbPaginationElm') ngbPaginationElm: any;

  //Filtro del grid
  filtro = {
    buscar: ""
  };

  constructor(
    private _toastr: ToastrService,
    private _wjHelper: WijmoHelper,
    private _changeDetector: ChangeDetectorRef,
    private _modalService: NgbModal,
    private _sTable: TableService,

    private _sModelo: ModeloService,
    private _sAuth: AuthenticationService,
    private _sMatricula: MatriculaService,
    private _sResponsablePago: ResponsablePagoService,
    private _sEstudiante: EstudianteService,
    private _sOtrasPersonas: OtrasPersonasService,
    private _sCobro: CobrosService,
    private _sRecibo: RecibosService,
    public _sExtracto: ExtractoService,
    private _sTarea: TareaServidorService
  ) {
    super(_toastr, _wjHelper, _sModelo, _changeDetector, _sTable, _sAuth, _sMatricula,
      _sResponsablePago, _sEstudiante, _sOtrasPersonas, _sCobro, _sRecibo, _sExtracto,_sTarea);
  }

  ngAfterViewInit(): void {
  }

  ngOnInit() {

    //Genera el objeto con el cual va traer las respectivas consultas que se está solicitando
    this.setModelosTrabajo2({
      identificador: "Odata",
      odata: [
        'TareaServidor;$orderby=Fecha desc&$top=50&$inlinecount=allpages'
      ]
    });

    //Carga la consulta con identificador 'Odata'
    this.cargarDatos("Odata", () => { });
  }

  /**
   * Trae los datos de las consultas realizadas
   * @param data El array u objeto que se esta consultado
   * @param identificador El identificador que ha sigo asignado a cada consulta
   */
  onDatosObtenidos(data: any, identificador: string) {

    //Carga los datos de la consulta de Odata
    if (identificador == "Odata") {

      this.countItems = data['TareaServidor'].count;
      this.tareasServidor = data['TareaServidor'].results;

      this.cvTareasServidor = new CollectionView(this.tareasServidor);

      this.cvTareasServidor.trackChanges = true;

      this.registrarModeloCollectionViews([
        new ModeloCollectionView('TareaServidor', 'IdTareaServidor', this.cvTareasServidor, this.flexTareasServidor)
      ]);
    }
  }

  /**
   * Actualiza las columnas que va tener el grid
   * @param column dato de la columna
   * @param modelo nombre del primer parametro en el new ModeloCollectionView
   */
  onAjusteColumna(column: WjFlexGridColumn, modelo: string) {
    if (modelo == "TareaServidor") {
      switch (column.binding) {
        default:
      }
    }
  }

  /**
   * Permite navegar entre páginas
   */
  cargarPagina() {
    this.cargarPaginaModelo('TareaServidor;$orderby=Fecha desc', this.ngbPaginationElm.page, 50, (data) => {
      
      this.cvTareasServidor.sourceCollection = data;
    }, true);
  }

  /**
   * Abre el tap para editar la tarea servidor
   */
  editar() {

    let item = this.flexTareasServidor.selectedItems[0];

    if (!this.verificarSiHayCambios())
      recaudoUI.tabsManager.agregar("Tarea Servidor - " + item["Nombre"], "", TareaServidorComponent, { idTareaServidor: item.IdTareaServidor });
  }

  /**
   * Permite al tap detectar si hay cambios o no, para el momento de ser cerrado
   */
  consultarSiHayCambios() {
    this.hayCambios = this.getTieneCambios();
    return this.hayCambios;
  }
}
